import React from 'react'

const AuthUserContext = React.createContext({
    auth: null,
    avatar: null,
    login: () => {},
    logout: () => {},
    fetchAvatar: () => {},
})

export default AuthUserContext;
